define('modules/domain_listing/views/confirm_delete_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/confirm_delete_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/confirm_delete_popup"),
    triggers: {
      "click .js-ok": "confirm",
      "click .js-cancel": "cancel"
    },
    onRender: function() {
      this.$el.i18n();
    }
  },{
    show: function(domain) {
      var defer = $.Deferred(),
          popup = new module.exports({model: domain});
      popup.on("confirm", defer.resolve, defer);
      popup.on("cancel hide", defer.reject, defer);
      popup.on("confirm cancel", popup.hide, popup);
      return defer.promise();
    }
  });

});

